import {attendeeFetchData} from "./index";

const profileAPI = {
  fetch: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/verify`)
}

export default profileAPI